export const EMPLOYEE_SESSION = 'Employee Sessions';
export const ADD_EMPLOYEE_SESSION = 'Add Employee Session';
export const EDIT_EMPLOYEE_SESSION = 'Edit Employee Session';

// V2 screens — employee-first navigation per spec §2.
// Old TABLE/FORM/REPORT pages are retained for the manual clock-in form path.
export const EMPLOYEE_SESSION_PAGES = {
  TABLE: 'table',
  FORM: 'form',
  REPORT: 'report',
  EMPLOYEES: 'employees', // Home — list of employees
  EMPLOYEE_SESSIONS: 'employeeSessions', // Sessions for selected employee
  SESSION_REPORTS: 'sessionReports', // 5 report cards for selected session
  REPORT_DETAIL: 'reportDetail', // One report opened
};

export const BONUS_GAMES = ['FIRE LINK', 'WIN Bolitas', 'LOL', 'POG'];

// Per spec §4 duplicate-detection scoring thresholds
export const DUPLICATE_FLAG_THRESHOLDS = {
  MEDIUM: 75,
  HIGH: 95,
};

// Spec §11 — report types in display order
export const REPORT_TYPES = [
  { id: 'shift', label: 'Shift' },
  { id: 'bonus', label: 'Bonus' },
  { id: 'points', label: 'Points' },
  { id: 'ticket', label: 'Ticket Out' },
  { id: 'raffle', label: 'Raffle' },
];

// Spec §5 — Identity verification photo metadata
export const RAFFLE_PHOTO_LABELS = {
  ID: 'ID Picture',
  VALIDATION: 'Validation Picture',
};
// tooltip names
export const BACK = 'Back to Menu';
export const ROWS_PER_PAGE = 50;
export const DEFAULT_SORT_BY_HEAD_CELL = 'date';
export const ROWS_PER_PAGE_LABEL = 'Results';

export const EMPLOYEE_SESSION_FIELDS = [
  { id: 'name', label: 'Employee Name', align: 'center' },
  { id: 'clockIn', label: 'Clock In', align: 'center' },
  { id: 'clockOut', label: 'Clock Out', align: 'center' },
  { id: 'totalHours', label: 'Total Working Hours', align: 'center' },
  { id: 'totalPay', label: 'Total Pay', align: 'center' },
  { id: 'state', label: 'State', align: 'center' },
];

export const STATE_OPTIONS = [{ name: 'Paid' }, { name: 'Unpaid' }];
